// extracted by mini-css-extract-plugin
module.exports = {"search_box":"SearchBox_search_box__oUgGw"};